import { render, staticRenderFns } from "./ListaUsuariosDesnviculados.vue?vue&type=template&id=69476504"
import script from "./ListaUsuariosDesnviculados.vue?vue&type=script&lang=js"
export * from "./ListaUsuariosDesnviculados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports